import { cx } from "@emotion/css";
import { memo, PropsWithChildren } from "react";

export const ActionPanel = memo((props: PropsWithChildren<{ fullyCollapse?: boolean; className?: string }>) => {
  return (
    <div
      className={cx(
        "ActionPanel flex-1 flex justify-end relative",
        !props.fullyCollapse && "sm-w:min-w-[64px] lg-w:min-w-[185px]",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
});
